import { render, staticRenderFns } from "./labour.vue?vue&type=template&id=35f8e7c8&scoped=true"
import script from "./labour.vue?vue&type=script&lang=js"
export * from "./labour.vue?vue&type=script&lang=js"
import style0 from "./labour.vue?vue&type=style&index=0&id=35f8e7c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f8e7c8",
  null
  
)

export default component.exports